import React from 'react'
import UserList from './List'
import { Layout } from 'antd'
import Header from '../Header'

const { Content } = Layout

const User = (props) => {
  return (
    <Layout className='layout'>
      <Header item='user' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <UserList />
        </div>
      </Content>
    </Layout>
  )
}

export default User
